/** Default role stored on `users/{uid}` in Firestore (aligns with morgen-style documents). */
export function getDefaultUserRole(): string {
  return 'user';
}
